import { FilterDefs, multiFilter, NestedOption, toggleFilter, treeFilter } from "@homebound/beam";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { BuyoutStatus, ProjectItemFilter, Stage } from "src/generated/graphqlTypes";
import { SpecsAndSelectionsCostCodeFragment } from "src/routes/projects/selections/SpecsAndSelectionsPage.generated";
import { costTypeToNameMapper, safeEntries } from "src/utils";

export type SpecsAndSelectionsFilter = ProjectItemFilter & {
  // UI-side adapter: bound to the backend `locationInPath: [ID!]` filter so that
  // selecting a group/room node also matches items on descendant locations.
  locationId?: string[];
  unallocatedCosts?: boolean;
};

export function createSpecsAndSelectionsFilterDef(
  stage: Stage,
  costCodes: SpecsAndSelectionsCostCodeFragment[],
  locations: NestedOption<NamedFragment>[],
): FilterDefs<SpecsAndSelectionsFilter> {
  return {
    locationId: treeFilter({
      label: "Location",
      // "root" so that selecting a group/room node sends only that node's id;
      // the backend's `locationInPath` filter then matches all descendants.
      filterBy: "root",
      options: locations,
      getOptionValue: (location) => location.id,
      getOptionLabel: (location) => location.name,
    }),
    costCode: multiFilter({
      options: costCodes,
      getOptionValue: (costCode) => costCode.id,
      getOptionLabel: (costCode) => costCode.name,
    }),
    costType: multiFilter({
      options: safeEntries(costTypeToNameMapper),
      getOptionValue: ([code]) => code,
      getOptionLabel: ([_, name]) => name,
    }),
    buyoutStatus: multiFilter({
      options: safeEntries({
        [BuyoutStatus.BoughtOut]: "Yes",
        [BuyoutStatus.NotBoughtOut]: "No",
        [BuyoutStatus.PartiallyBoughtOut]: "Partially",
      }),
      getOptionValue: ([code]) => code,
      getOptionLabel: ([_, name]) => name,
    }),
    unallocatedCosts: toggleFilter({ label: "Unallocated costs" }),
  };
}
